/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-stepper.scss'
import template from 'lui-stepper.html'

export default class LuiStepper extends LuiBase {
  static get is() {
    return 'lui-stepper'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  onConnected() {
    this._onChange = this._onChange || ((event) => {
      if (event.target.selected) {
        this._deselectLastTab(event.target)
      }
    })
    if (window.lui.usePolyfills) {
      requestAnimationFrame(() => {
        this.addEventListener('change', this._onChange)
      })
    } else {
      this.addEventListener('change', this._onChange)
    }
  }

  onDisconnected() {
    this.removeEventListener('change', this._onChange)
  }

  init() {
    this._generateStepCount()
  }

  _deselectLastTab(currentSelectedStep) {
    this.allSteps().forEach((step) => {
      if (currentSelectedStep !== step) {
        step.selected = false
        if (!step.disabled) {
          step.seedElement.classList.add('lui-interactive')
        }
      }
    })
  }

  _generateStepCount() {
    let stepCount = 1
    let steps = this.allSteps()

    steps.forEach((step) => {
      let badge = step.shadowRoot.querySelector('.lui-step__badge')
      badge.textContent = stepCount
      if (stepCount === steps.length) {
        step.shadowRoot.querySelector('.lui-step__spacer').style.display = 'none'
      }
      stepCount += 1
    })
  }

  allSteps() {
    return Array.from(this.querySelectorAll('lui-step'))
  }

  selectedStep() {
    return this.querySelector('lui-step[selected]')
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-stepper/lui-stepper.js
// module id = 329
// module chunks = 0 1 7